import { Component, Input, OnInit } from '@angular/core';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { InteractiveContentDisplayComponent } from '../interactive-content-display-component.interface';

@Component({
  selector: 'ft-recession-dashboard',
  templateUrl: './recession-dashboard.component.html',
  styleUrls: ['./recession-dashboard.component.scss'],
})
export class RecessionDashboardComponent
  implements InteractiveContentDisplayComponent {
  showResult: boolean;
  config: any;
  brLabels = {};

  populate(config: any, labels: any, component: BrComponent, page: Page): void {
    if (config) {
      this.config = config;
    }

    if (labels) {
      this.brLabels = labels;
    }
  }
}
